import cx from 'classnames';
import {useMemo} from 'react';
import {Button} from '../atoms/Button';
import {Pill} from '../atoms/Pill';
import {Typography} from '../atoms/Typography';
import {charcoal, premiumColor} from '../sass/base/_exports.sass';
import {MinusIcon} from '../svg/MinusIcon';
import {PremiumIcon} from '../svg/PremiumIcon';
import {PlusIcon} from '../svg/v2/PlusIcon';

export const FeatureController = ({
  title,
  titleVariant = 'paragraph3',
  titleColor = 'charcoal',
  titleBold = true,
  subtitle,
  subtitleVariant = 'list1',
  subtitleColor = 'asphalt',
  startAdornment = null,
  editable = false,
  filled = false,
  disabled = false,
  onClick,
  qaId,
  premiumFeature = false,
  renderAs = 'block',
  hide = false,
}) => {
  const endAdornment = useMemo(() => {
    if (filled) {
      if (editable) {
        return (
          <Typography variant="link" className="feature-controller__toggle">
            Edit
          </Typography>
        );
      }
      return (
        <Typography variant="link" className="feature-controller__toggle">
          Remove
        </Typography>
      );
    }
    return (
      <Typography variant="link" className="feature-controller__toggle">
        Add
      </Typography>
    );
  }, [filled, editable]);

  if (renderAs === 'pill') {
    const StartIcon = filled ? MinusIcon : PlusIcon;
    return (
      <Pill
        startAdornment={<StartIcon color={charcoal} ratio={0.5} />}
        endAdornment={premiumFeature ? <PremiumIcon color={premiumColor} ratio={0.088} /> : null}
        title={title}
        data-qa-id={qaId}
        onClick={onClick}
        className={cx('feature-controller__pill', {hide})}
      />
    );
  }

  return (
    <Button
      variant="unstyled-button"
      className={cx('feature-controller__button', {hide})}
      onClick={onClick}
      disabled={disabled}
      data-qa-id={qaId}
      id={qaId}
      data-qa-value={filled}
    >
      {startAdornment}
      <div className="feature-controller__content">
        <div className="feature-controller__title">
          <Typography variant={titleVariant} color={titleColor} semibold={titleBold}>
            {title}
          </Typography>
          {premiumFeature && (
            <PremiumIcon color={premiumColor} ratio={0.088} /> // Scale down from 180px to 16px
          )}
        </div>
        {subtitle && (
          <Typography variant={subtitleVariant} color={subtitleColor}>
            {subtitle}
          </Typography>
        )}
      </div>
      {endAdornment}
    </Button>
  );
};
